/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class GeneralService {
    flowId: string = '';
    ottStatus: string = 'missing';
    public transactionId: string = '';
    scofAuthenticationMethod: string = '';
    constructor() {

        // window.AUTHSDK_MASTERCARD.authenticate(requestPayload);
        // this.srciUsWindowObject = new (window as any).AUTHSDK_MASTERCARD;
    }

    setFlowId(id: string): void {
        this.flowId = id;
    }
    getFlowId(): string | '' {
        return this.flowId;
    }
    setScofMethod(method: string): void {
        this.scofAuthenticationMethod = method;
        localStorage.setItem('scofMethod', method);
    }
    getScofMethod(): string | '' {
        if (!this.scofAuthenticationMethod) {
            this.scofAuthenticationMethod = localStorage.getItem('scofMethod') || '';
        }
        return this.scofAuthenticationMethod;

    }
    setTransactionId(id: string): void {
        this.transactionId = id;
        localStorage.setItem('transactionId', id);
    }
    getTransactionId(): string | '' {
        if (!this.transactionId) {
            this.transactionId = localStorage.getItem('transactionId') || '';
        }
        return this.transactionId;
    }
}